export default "__VITE_ASSET__CxcPMUI4__"